import React from 'react'
import { Fragment } from 'react'
import Navbar from '../../component/Other/Navbar'
import Head from '../../component/Page/Head'
import SecContact from '../../component/Page/SecContact'
import Footer from '../../component/Other/Footer'
import AccordionFaq from '../../component/Other/AccordionFaq'

const Faq = () => {
    const dataAccordion = [
        {
            title: "What payment methods do you accept?",
            desc: "Our plant rental service includes a selection of high-quality, low-maintenance plants that are perfect for any indoor environment. From small desk plants to large statement pieces, we have a range of options to suit your needs. Our plants are sourced from local growers and are carefully chosen for their health and beauty."
        },
        {
            title: "How often should I water my plants?",
            desc: "Our plant rental service includes a selection of high-quality, low-maintenance plants that are perfect for any indoor environment. From small desk plants to large statement pieces, we have a range of options to suit your needs. Our plants are sourced from local growers and are carefully chosen for their health and beauty."
        },
        {
            title: "Do you offer international shipping?",
            desc: "Our plant rental service includes a selection of high-quality, low-maintenance plants that are perfect for any indoor environment. From small desk plants to large statement pieces, we have a range of options to suit your needs. Our plants are sourced from local growers and are carefully chosen for their health and beauty."
        },
        {
            title: "How do I care for my new plant?",
            desc: "Our plant rental service includes a selection of high-quality, low-maintenance plants that are perfect for any indoor environment. From small desk plants to large statement pieces, we have a range of options to suit your needs. Our plants are sourced from local growers and are carefully chosen for their health and beauty."
        },
        {
            title: "What size planter should I choose for my plant?",
            desc: "Our plant rental service includes a selection of high-quality, low-maintenance plants that are perfect for any indoor environment. From small desk plants to large statement pieces, we have a range of options to suit your needs. Our plants are sourced from local growers and are carefully chosen for their health and beauty."
        },
        {
            title: "What payment methods do you accept?",
            desc: "Our plant rental service includes a selection of high-quality, low-maintenance plants that are perfect for any indoor environment. From small desk plants to large statement pieces, we have a range of options to suit your needs. Our plants are sourced from local growers and are carefully chosen for their health and beauty."
        },
        {
            title: "Do you offer payment plans or financing options?",
            desc: "Our plant rental service includes a selection of high-quality, low-maintenance plants that are perfect for any indoor environment. From small desk plants to large statement pieces, we have a range of options to suit your needs. Our plants are sourced from local growers and are carefully chosen for their health and beauty."
        },
        {
            title: "How much light do my plants need?",
            desc: "Our plant rental service includes a selection of high-quality, low-maintenance plants that are perfect for any indoor environment. From small desk plants to large statement pieces, we have a range of options to suit your needs. Our plants are sourced from local growers and are carefully chosen for their health and beauty."
        },
    ]
    return (
        <Fragment>
            <div className="overflow-hidden">
                <div className="position-relative">
                    <Navbar />
                    <Head title={"FAQ"} to={"FAQ"} />
                </div>

                <section className='mb-5'>
                    <div className="container">
                        <div className="text-center mb-5">
                            <h2 className='normal font__size--50 text__50-1024 text__50-sm text__50-xs'>Frequently Asked Questions (FAQ)</h2>
                            <p className='normal font__size--14 text__14-1024 color__gray-1 mb-4'>We want to make sure you have all the information you need to make informed decisions about your plant purchases and care. Here are some <br className='d-none d-lg-block' /> common questions we receive from our customers:</p>

                            <div className="wrapper__tag-blog faq flex-wrap flex-md-nowrap medium font__size--16 text__16-1024">
                                <div className="item mb-4 mb-md-0 pointer active">
                                    General Questions
                                </div>
                                <div className="item mb-4 mb-md-0 pointer">
                                    Product Questions
                                </div>
                                <div className="item mb-4 mb-md-0 pointer">
                                    Payment Questions
                                </div>
                            </div>
                        </div>


                        <div className="row justify-content-center">
                            <div className="col-md-8">
                                {
                                    dataAccordion.map((obj) => {
                                        return <div className="mb-4">
                                            <AccordionFaq data={obj} />
                                        </div>
                                    })
                                }


                            </div>
                        </div>

                    </div>
                </section>

                <SecContact />

                <Footer />
            </div>
        </Fragment>
    )
}

export default Faq